import * as React from 'react';
import { useLocalization } from '@shared-ui/localization-context';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkPrimaryButton } from 'uitk-react-button';
import { UitkHeading, UitkText } from 'uitk-react-text';
import { UitkEmptyState, UitkEmptyStateActionArea } from 'uitk-react-empty-state';
import { UitkBanner } from 'uitk-react-banner';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
export var ErrorMessageType;
(function (ErrorMessageType) {
  ErrorMessageType["SEARCH_ERROR"] = "SEARCH_ERROR";
  ErrorMessageType["OFFER_UNAVAILABLE"] = "OFFER_UNAVAILABLE";
  ErrorMessageType["BOOKING_ERROR"] = "BOOKING_ERROR";
  ErrorMessageType["DEFAULT"] = "DEFAULT";
})(ErrorMessageType || (ErrorMessageType = {}));
export var ErrorBanner = function (_a) {
  var type = _a.type,
    onButttonClick = _a.onButttonClick;
  var formatText = useLocalization().formatText;
  var renderErrorBanner = function (errorType) {
    switch (errorType) {
      case 'SEARCH_ERROR':
        return React.createElement("div", {
          "data-testid": "search-error"
        }, React.createElement(UitkText, {
          align: "center"
        }, React.createElement(UitkSpacing, {
          padding: {
            blockstart: 'six',
            blockend: 'twelve'
          }
        }, React.createElement(UitkEmptyState, {
          fullscreen: true
        }, React.createElement(UitkIcon, {
          name: "search",
          size: UitkIconSize.LARGE
        }), React.createElement(UitkHeading, {
          size: 5,
          tag: "h3"
        }, formatText('lx.search.errors.searchFailed')), React.createElement(UitkEmptyStateActionArea, null, React.createElement(UitkSpacing, {
          margin: {
            blockstart: 'six'
          }
        }, React.createElement(UitkPrimaryButton, {
          name: "textonly",
          type: "button",
          onClick: onButttonClick
        }, formatText('lx.search.errors.retry.button.text'))))))));
      case 'OFFER_UNAVAILABLE':
        return React.createElement(UitkSpacing, {
          margin: {
            blockstart: 'three',
            inline: 'three'
          }
        }, React.createElement("div", {
          "data-testid": "offer-unavailable-error"
        }, React.createElement(UitkBanner, null, React.createElement(UitkLayoutFlex, {
          alignItems: "center",
          space: "two"
        }, React.createElement(UitkLayoutFlexItem, null, React.createElement("div", null, React.createElement(UitkIcon, {
          name: "warning"
        }))), React.createElement(UitkLayoutFlexItem, null, React.createElement("div", null, React.createElement(UitkText, null, formatText('lx.search.errors.offers.not.available')))))), ' '));
      case 'BOOKING_ERROR':
        return React.createElement(UitkSpacing, {
          margin: {
            blockstart: 'three',
            inline: 'three'
          }
        }, React.createElement("div", {
          "data-testid": "booking-error"
        }, React.createElement(UitkBanner, null, React.createElement(UitkLayoutFlex, {
          alignItems: "center",
          space: "two"
        }, React.createElement(UitkLayoutFlexItem, null, React.createElement("div", null, React.createElement(UitkIcon, {
          name: "warning"
        }))), React.createElement(UitkLayoutFlexItem, null, React.createElement("div", null, React.createElement(UitkText, null, formatText('lx.activity.booking.error')))))), ' '));
      default:
        return React.createElement(UitkSpacing, {
          margin: {
            blockstart: 'three',
            inline: 'three'
          }
        }, React.createElement("div", {
          "data-testid": "default-error"
        }, "Error"));
    }
  };
  return renderErrorBanner(type);
};